// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  MODO: 'DEV_LOCAL',
  // API: 'http://localhost:3062',
  API: 'https://dev-mod-site.meuvidraceiro.com.br/api',
  NOME_SISTEMA: 'site_mv',
  MODULO_ZEMT: {
    // API: 'http://localhost:3020',
    API: 'https://developera.meuvidraceiro.com.br/api',
  },
  moduloBI: {
    API: 'https://dev-bi.meuvidraceiro.com.br/api',
    //  API: 'http://localhost:3063',
    NOME: 'adm_mv',
  },
  mautic: {
    API: 'https://zemt.com.br/dev-webhook-mv/',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
